import { render, staticRenderFns } from "./RentalObjectSmallLandlord.vue?vue&type=template&id=dbfb28aa&scoped=true&"
import script from "./RentalObjectSmallLandlord.vue?vue&type=script&lang=js&"
export * from "./RentalObjectSmallLandlord.vue?vue&type=script&lang=js&"
import style0 from "./RentalObjectSmallLandlord.vue?vue&type=style&index=0&id=dbfb28aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfb28aa",
  null
  
)

export default component.exports